import { EstateApplicationStageType } from '@contexts/Estate/EstateApplication/domain';

export type EstateApplicationResultItem = {
  key: string;
  aplicationNumber: string;
  titleEstate: string;
  result: EstateApplicationResultItemResult;
  imgState: string;
  action: () => void;
};

export enum EstateApplicationResultItemResult {
  APPROVED = 'APPROVED',
  INCOMPLETE = 'INCOMPLETE',
  PRE_APPROVED = 'PRE_APPROVED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export const EstateApplicationResultItemResultTranslate: Record<
  EstateApplicationResultItemResult,
  string
> = {
  APPROVED: '¡Aprobaste!',
  INCOMPLETE: 'Aplicación incompleta',
  PRE_APPROVED: 'Necesitas un coarrendatario',
  REJECTED: 'Rechazada',
  EXPIRED: 'Expirada',
  UNAVAILABLE: 'Inmueble no disponible',
};

export const getEstateApplicationResult = (
  estateApplicationStage: EstateApplicationStageType
) => {
  switch (estateApplicationStage) {
    case EstateApplicationStageType.APPROVED:
      return EstateApplicationResultItemResult.APPROVED;
    case EstateApplicationStageType.PRE_APPROVED:
      return EstateApplicationResultItemResult.PRE_APPROVED;
    case EstateApplicationStageType.REJECTED:
      return EstateApplicationResultItemResult.REJECTED;
    case EstateApplicationStageType.EXPIRED:
      return EstateApplicationResultItemResult.EXPIRED;
    default:
      return EstateApplicationResultItemResult.INCOMPLETE;
  }
};
